import type { AriOperationState } from '@/shared/api';

export function isTerminalAriOperation(status: AriOperationState): boolean {
  return status !== 'Queued' && status !== 'Retrying';
}

export function shouldDisplayAriOperation(status: AriOperationState): boolean {
  return status !== 'Confirmed' && status !== 'SentUnverified';
}

export function ariOperationLabel(status: AriOperationState): string {
  switch (status) {
    case 'Queued':
      return 'Vorgemerkt';
    case 'Retrying':
      return 'Erneuter Versuch';
    case 'Confirmed':
      return 'Von Channex bestätigt';
    case 'Drifted':
      return 'Abweichung erkannt';
    case 'SentUnverified':
      return 'Gesendet';
    case 'Suppressed':
      return 'Nicht übertragen';
    case 'Failed':
      return 'Fehlgeschlagen';
  }
}

export function ariOperationDescription(status: AriOperationState): string {
  switch (status) {
    case 'Queued':
      return 'Die Änderung wartet in der sicheren Warteschlange.';
    case 'Retrying':
      return 'Der erste Versuch war nicht erfolgreich. StayOn versucht es automatisch erneut.';
    case 'Confirmed':
      return 'Die übertragenen Werte wurden bei Channex zurückgelesen und stimmen überein.';
    case 'Drifted':
      return 'Channex liefert nach der Übertragung andere Werte zurück. Bitte prüfen.';
    case 'SentUnverified':
      return 'Die Übertragung wurde verarbeitet, konnte aber nicht eindeutig zurückgelesen werden.';
    case 'Suppressed':
      return 'Die Änderung wurde wegen des aktuellen Apartmentzustands nicht übertragen.';
    case 'Failed':
      return 'Die Änderung konnte auch nach automatischen Wiederholungen nicht übertragen werden.';
  }
}
